import React from 'react';
import TradePageGrid from './TradePageGrid';

const TradePageGridAndCustomiser = () => {
	return (
		<div className="flex flex-col w-full h-full sm:min-h-[950px] lg:min-h-[700px]">
			<TradePageGrid />
		</div>
	);
};

export default TradePageGridAndCustomiser;
